<template>
<v-list-tile v-if="isEditable" @click="maybeRemove">
	<v-list-tile-action>
		<v-icon small>fa-trash</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Delete</v-list-tile-title>
		<v-list-tile-sub-title small>Permanently remove this entry</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionDelete",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),

		isEditable () {
			return this.row.entity.isEditableBy(this.user);
		}
	},

	methods: {
		...Vuex.mapActions({ confirmDelete: 'dialogue/confirm/confirmDelete' }),

		maybeRemove () {
			// TODO
			console.log("DELETE ACTION HANDLER");
			this.confirmDelete( ( answer ) => {
				if (answer) {
					console.log("DELETE CONFIRMED");
				} else {
					console.log("DELETE CANCELLED");
				}
			});
		}
	}
};

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionDelete.vue